import { HttpClient } from "@angular/common/http";
import { map, catchError, firstValueFrom } from "rxjs";
import { httpOptionsDefault } from "../../_shared/constants";
import { WebApiService } from "../WebApiService";



export class OreController {


  constructor(public _http: HttpClient, private _webApi: WebApiService) {
  }


  createOrder(schemeId): Promise<any> {



    return this._http.get(this._webApi.GetApiAddress() + `/ore/createOrder/${schemeId}`, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result;
      });

  }

  getLicenses() {

    return this._http.get(this._webApi.GetApiAddress() + `/ore/licenses`, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: any) => {


        return result;
      });
  }


getRenweUrl(): Promise<string> {
  return firstValueFrom(
    this._http.get<{ url: string }>(this._webApi.GetApiAddress() + `/ore/RenewUrl`, httpOptionsDefault)
      .pipe(
        map(res => res.url),
        catchError(error => { throw error; })
      )
  );
}

getLicense(deviceType:string): Promise<any> {

  return firstValueFrom(
    this._http.get(this._webApi.GetApiAddress() + `/ore/license/${deviceType}`, httpOptionsDefault)
      .pipe(
        map(result => result),
        catchError(error => {
          throw error;  // <-- importante: catchError deve lançar erro, não retornar.
        })
      )
  );
}

}
